import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import { getMonthCntList } from 'lib/api/script';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import FunctionWrap from 'components/molecules/FunctionWrap';
import NewButton from 'components/molecules/NewButton';

const MonthCnt = (props) => {
  const { handleLoading } = props;
  const [params] = useState({});
  const [copyText, setCopyText] = useState('');

  const customized = {
    MONTHCNT_ID: { merged: true },
    MONTHCNT_TOTAL_CNT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'MONTHCNT_TOTAL_CNT');
        return rowObj['MONTHCNT_NAEM'] === '구분'
          ? '-'
          : makeRowColumn(
              rowObj['MONTHCNT_TOTAL_CNT'],
              bodyItem1.type,
              bodyItem1.format
            );
      },
    },
  };

  const handleCopyText = () => {
    const copyText = document.getElementById('copyText');
    copyText.select();
    document.execCommand('copy');
  };

  const handleCallBack = (status, data) => {
    handleLoading(false);
    const checkId = [
      '611e09d2242fab6a55924902',
      '60a5bc1668c9ea0c860084f2',
      '601b8c694643063a0a71d60c',
      '601b8c7107b6f78384acae7c',
      '5ff52fc44de2b36fd3223da6',
      '5da6b74c20da562a3a248806',
      '5ff52fdc504a8858996f1b5d',
      '5eb246e071401c521d9c3ade',
    ];
    const phpCheckId = ['5cbfbf4154f5d588038620fd', '5bf20f85b24d248f5b160448'];

    let newCnt = {
      'LIST_01': 0,
      'LIST_02': 0,
      'LIST_03': 0,
      'LIST_04': 0,
      'LIST_05': 0,
      'LIST_06': 0,
      'LIST_07': 0,
      'LIST_08': 0,
      'LIST_09': 0,
      'LIST_10': 0,
      'LIST_11': 0,
      'PHP': 0,
      'SCRIPT': 0,
    };
    for (let row of data) {
      if (
        !checkId.includes(row['MONTHCNT_ID']) &&
        row['MONTHCNT_TYPE'] === '2.0'
      ) {
        newCnt['LIST_01'] = newCnt['LIST_01'] + row['MONTHCNT_LIST_01'];
        newCnt['LIST_02'] = newCnt['LIST_02'] + row['MONTHCNT_LIST_02'];
        newCnt['LIST_03'] = newCnt['LIST_03'] + row['MONTHCNT_LIST_03'];
        newCnt['LIST_04'] = newCnt['LIST_04'] + row['MONTHCNT_LIST_04'];
        newCnt['LIST_05'] = newCnt['LIST_05'] + row['MONTHCNT_LIST_05'];
        newCnt['LIST_06'] = newCnt['LIST_06'] + row['MONTHCNT_LIST_06'];
        newCnt['LIST_07'] = newCnt['LIST_07'] + row['MONTHCNT_LIST_07'];
        newCnt['LIST_08'] = newCnt['LIST_08'] + row['MONTHCNT_LIST_08'];
        newCnt['LIST_09'] = newCnt['LIST_09'] + row['MONTHCNT_LIST_09'];
        newCnt['LIST_10'] = newCnt['LIST_10'] + row['MONTHCNT_LIST_10'];
        newCnt['LIST_11'] = newCnt['LIST_11'] + row['MONTHCNT_LIST_11'];
      } else if (
        !phpCheckId.includes(row['MONTHCNT_ID']) &&
        row['MONTHCNT_TYPE'] === 'php'
      ) {
        newCnt['PHP'] = newCnt['PHP'] + row['MONTHCNT_TOTAL_CNT'];
      } else if (row['MONTHCNT_TYPE'] === 'script') {
        newCnt['SCRIPT'] = row['MONTHCNT_TOTAL_CNT'];
      }
    }
    let newText = `- PHP배포
  -- 최고관리자 ${newCnt['PHP']}건
  -- 관리자2.0 frontEnd ${newCnt['LIST_02']}건
  -- 관리자2.0 backEnd ${newCnt['LIST_01']}건
  -- 광고주센터 frontEnd ${newCnt['LIST_03']}건
  -- 광고주센터 backEnd ${newCnt['LIST_04']}건
  -- 모비센스 ${newCnt['LIST_05']}건
  -- TUNE720 ${newCnt['LIST_06']}건
  -- 모비믹서 ${newCnt['LIST_07']}건
  -- 모비피드 ${newCnt['LIST_08']}건
  -- 애드허브 ${newCnt['LIST_09']}건
  -- 모비랩 ${newCnt['LIST_10']}건
  -- 인라이플홈페이지 ${newCnt['LIST_11']}건

* 스크립트
 - 스크립트&인사이트 ${newCnt['SCRIPT']}건 진행`;
    setCopyText(newText);
  };

  return (
    <>
      <FunctionWrap loading={false}>
        <NewButton name="addName" onClick={handleCopyText}>
          TEXT COPY
        </NewButton>
        <textarea
          id="copyText"
          value={copyText}
          style={{ position: 'fixed', top: -99, left: -99 }}
          readOnly
        />
      </FunctionWrap>
      <NewTableContainer
        params={params}
        dataReqPromise={getMonthCntList}
        getParam={(f) => f}
        useSearch={false}
        useFetch={false}
        useTotal={false}
        useToolBar={false}
        customized={customized}
        rowsPerPage={-1}
        usePagenation={false}
        callBack={handleCallBack}
      />
    </>
  );
};

export default withRouter(MonthCnt);
